import { render, staticRenderFns } from "./AnnotationsPanel.vue?vue&type=template&id=60d2c81b&scoped=true&"
import script from "./AnnotationsPanel.vue?vue&type=script&lang=js&"
export * from "./AnnotationsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsPanel.vue?vue&type=style&index=0&id=60d2c81b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d2c81b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins\\workspace\\Apps\\WebViewer\\Dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('60d2c81b', component.options)
    } else {
      api.reload('60d2c81b', component.options)
    }
    module.hot.accept("./AnnotationsPanel.vue?vue&type=template&id=60d2c81b&scoped=true&", function () {
      api.rerender('60d2c81b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\uScope\\js\\extensions\\annotations\\annotations-ui\\AnnotationsPanel.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/annotations/annotations-ui/AnnotationsPanel.vue
// module id = 385
// module chunks = 0